/**
 * handle generic form validator code error
 */
export enum ValidatorsError {
  DATE_EMPTY = 0,
  DATE_INVALID_FORMAT = 1,
  DATE_INVALID_FORMAT_SINGLE_DIGIT_DAY = 2,
  DATE_INVALID_FORMAT_SINGLE_DIGIT_MONTH = 3,
  DATE_INVALID_FORMAT_SINGLE_DIGIT_DAY_MONTH = 4,
  DATE_INVALID_FORMAT_NO_SEPARATOR = 5,
  TIME_EMPTY = 6,
  TIME_WRONG_FORMAT_SHORT_HOUR = 7,
  TIME_WRONG_FORMAT_SHORT_MINUTES = 8,
  TIME_WRONG_FORMAT_SHORT_HOUR_MINUTES = 9,
  TIME_WRONG_FORMAT_SEPARATOR = 10,
  TIME_WRONG_FORMAT = 11,
  TIME_NO_SEPARATOR = 12,
  DATES_CONFLICT = 13,
  EMAIL_NEEDED = 14,
  PHONE_NUMBER_NEEDED = 15,
  IP_INVALID = 16,
  PWD_INVALID = 17,
}
